export const getArticleLabel = (
  title: string | null | undefined,
  erpItemNumber: string | null,
  artNoLabel: string | undefined
): string => {
  const artNo = `${artNoLabel}: ${erpItemNumber}`
  return title ? `${title} (${artNo})` : artNo
}
